export const ARABIC_DECIMAL_SEPARATOR = '٫';
export const characterWhitelist = ['?', ',', '@'];
